import api from './api';

export interface ImpostazioneTrascinaConfermare {
  enabled: boolean;
  descrizione: string;
}

export type OutboxStatus = {
  enabled: boolean,
  descrizione: string,
  profileFlag?: boolean,
  effectiveEnabled?: boolean
};

export const impostazioniService = {
  /**
   * Ottieni l'impostazione "Trascina per confermare sempre"
   */
  getTrascinaConfermareSempre: async (): Promise<ImpostazioneTrascinaConfermare> => {
    const response = await api.get('/impostazioni/trascina-confermare-sempre');
    return response.data;
  },

  /**
   * Aggiorna l'impostazione "Trascina per confermare sempre" (solo Admin)
   */
  updateTrascinaConfermareSempre: async (enabled: boolean): Promise<any> => {
    const response = await api.put('/impostazioni/trascina-confermare-sempre', { enabled });
    return response.data;
  },

  /**
   * Ottieni tutte le impostazioni (solo Admin)
   */
  getAllImpostazioni: async (): Promise<any[]> => {
    const response = await api.get('/impostazioni');
    return response.data;
  },

  /**
   * Ottieni una singola impostazione per chiave
   */
  getImpostazione: async (chiave: string): Promise<any> => {
    const response = await api.get(`/impostazioni/${chiave}`);
    return response.data;
  },

  /**
   * Salva o aggiorna un'impostazione (solo Admin)
   */
  salvaImpostazione: async (chiave: string, valore: string, descrizione?: string): Promise<any> => {
    const response = await api.post(`/impostazioni/${chiave}`, { valore, descrizione });
    return response.data;
  },

  /**
   * Elimina un'impostazione (solo Admin)
   */
  eliminaImpostazione: async (chiave: string): Promise<any> => {
    const response = await api.delete(`/impostazioni/${chiave}`);
    return response.data;
  }
  ,
  /**
   * Stato invio Outbox verso endpoint esterni
   */
  getOutboxEnabled: async (): Promise<OutboxStatus> => {
    const response = await api.get('/impostazioni/outbox-enabled');
    return response.data;
  },

  updateOutboxEnabled: async (enabled: boolean): Promise<any> => {
    const response = await api.put('/impostazioni/outbox-enabled', { enabled });
    return response.data;
  },

  /**
   * Ottieni la label del mese per il box LOG in dashboard
   */
  getLogMeseLabel: async (): Promise<string> => {
    const response = await api.get('/impostazioni/log-mese-label');
    return response.data?.mese ?? 'Febbraio';
  },

  /**
   * Aggiorna la label del mese per il box LOG in dashboard (solo Admin)
   */
  updateLogMeseLabel: async (mese: string): Promise<any> => {
    const response = await api.put('/impostazioni/log-mese-label', { mese });
    return response.data;
  }
};

export interface CoordinatoreLockEccezione {
  id: number;
  tipo: 'NEGOZIO' | 'COORDINATORE' | 'DIPENDENTE';
  valore: string;
  note?: string;
  creatoDa: string;
  creatoIl: string;
}

export const coordinatoreLockEccezioniService = {
  getAll: async (): Promise<CoordinatoreLockEccezione[]> => {
    const response = await api.get('/coordinatore-lock-eccezioni');
    return response.data;
  },

  getByTipo: async (tipo: 'NEGOZIO' | 'COORDINATORE' | 'DIPENDENTE'): Promise<CoordinatoreLockEccezione[]> => {
    const response = await api.get(`/coordinatore-lock-eccezioni/tipo/${tipo}`);
    return response.data;
  },

  create: async (tipo: 'NEGOZIO' | 'COORDINATORE' | 'DIPENDENTE', valore: string, note?: string, negozio?: string): Promise<CoordinatoreLockEccezione> => {
    const response = await api.post('/coordinatore-lock-eccezioni', { tipo, valore, note: note ?? '', negozio });
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/coordinatore-lock-eccezioni/${id}`);
  }
};
